import CloseIcon from "@mui/icons-material/Close";
import { FiRefreshCcw } from "react-icons/fi";
export const navbarIcons = {
  dashboardIcon: (
    <svg
      style={{ width: "26px", height: "26px" }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-menu"
    >
      <line x1="4" x2="20" y1="12" y2="12" />
      <line x1="4" x2="20" y1="6" y2="6" />
      <line x1="4" x2="20" y1="18" y2="18" />
    </svg>
  ),
  reload: (
    <svg
      style={{ width: "22px", height: "22px" }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <FiRefreshCcw
        size={24}
        color="#fff"
        style={{ stroke: "#fff", fill: "none" }}
      />
    </svg>
  ),
  plusIcon: (
    <svg
      style={{ width: "11px", height: "12px" }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      fill="#fff"
    >
      <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
    </svg>
  ),
  save: (
    <svg
      style={{
        position: "relative",
        top: "2px",
        width: "18.5px",
        height: "18.5px",
      }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      fill="#fff"
    >
      <path d="M48 96V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm80-16v80H272V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z" />
    </svg>
  ),
  closeIcon: (
    <CloseIcon style={{ color: "#fff", width: "26px", height: "26px" }} />
  ),
  alarmPLC: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-siren"
      stroke="#fff"
    >
      <path d="M7 18v-6a5 5 0 1 1 10 0v6" />
      <path d="M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z" />
      <path d="M21 12h1" />
      <path d="M18.5 4.5L18 5" />
      <path d="M2 12h1" />
      <path d="M12 2v1" />
      <path d="m4.929 4.929.707.707" />
      <path d="M12 12v6" />
    </svg>
  ),
};
